export default __webpack_public_path__ + "6716f487a7b652ee1e6bb901d456019e.svg";